/**
 * Route path constants.
 *
 * Every link in the application references these instead of hardcoded
 * strings, so renaming a URL is a one-line change and navigation data,
 * tests, and SEO can never drift apart.
 */
export const ROUTES = {
  home: '/',
  services: '/services',
  industries: '/industries',
  howItWorks: '/how-it-works',
  about: '/about',
  contact: '/contact',
  privacy: '/privacy-policy',
  terms: '/terms-of-use',

  /** Reserved for the future client portal / AI assistant surface. */
  portal: '/portal',
};

/** All routes that are fully public and should appear in the sitemap. */
export const PUBLIC_MARKETING_ROUTES = [
  ROUTES.home,
  ROUTES.services,
  ROUTES.industries,
  ROUTES.howItWorks,
  ROUTES.about,
  ROUTES.contact,
  ROUTES.privacy,
  ROUTES.terms,
];

export default ROUTES;
